// PL Personal Loan
export const PL_DEFAULT = 'PL_DEFAULT';
export const PL_JOINT = 'PL_JOINT';
export const UNIVERSAL_CREDIT_PL = 'UNIVERSAL_CREDIT_PL';
export const PL_UC_JOINT = 'PL_UC_JOINT';

// Home Improvement
export const HI_DEFAULT = 'HI_DEFAULT';
export const HI_P_01 = 'HI_P_01';
export const HI_PODS = 'HI_PODS';
export const HI_SECURED = 'HI_SECURED';

// Auto Refinance
// Note: Update the utils/pl/program-definition-codes.js in case of any changes
export const AUTO_REFI = 'AUTO_REFI';
export const AUTO_SECURED_CASHOUT = 'AUTO_SECURED_CASHOUT';
export const AUTO_SECURED = 'AUTO_SECURED';
export const AUTO_INDIRECT_PURCHASE = 'AUTO_INDIRECT_PURCHASE';
export const AUTO_PRE_QUALIFICATION_DEFAULT = 'AUTO_PRE_QUALIFICATION';

// PCL
export const CARD_NO_REWARDS = '00';
export const CARD_REWARDS_MVP = '01';
export const CARD_TRIPLE_CASH_REWARDS = '02';
export const CARD_UNLIMITED_CASH_REWARDS = '03';
export const CARD_REWARDS_BITCOIN = '04';
export const CARD_REWARDS_ELITE = '05';
export const CARD_TRIPLE_CASH_REWARDS_ZERO = '06';
export const CARD_REWARDS_ELITE_EARLY_PAY = '07';
export const CARD_REWARDS_BITCOIN_PLUS = '08';
export const CARD_LIFE_REWARDS = '09';
export const CARD_TRAVEL_CASH_REWARDS = '10';
export const LENDING_TREE_GROW = '11';
export const CARD_LIFE_REWARDS_ZERO = '12';
export const CARD_CREDIT_BUILDER = '13';
export const CARD_MYFIVE_CASH_REWARDS = '14';
export const CARD_MYFIVE_CASH_REWARDS_V2 = '15';
export const CARD_CASH_REWARDS_WITH_AUTOPAY = '16';

// Expanded Counter Offer
export const CARD_REWARDS_MVP_WITH_ANNUAL_FEE = '01_S01';
export const CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE = '02_S01';
export const CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE = '03_S01';
export const CARD_REWARDS_ELITE_WITH_ANNUAL_FEE = '05_S01';
export const CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE = '07_S01';
export const CARD_LIFE_REWARDS_WITH_ANNUAL_FEE = '09_S01';
export const CARD_TRAVEL_CASH_BACK_REWARDS_SELECT = '10_S01';
export const CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE = '14_S01';
export const CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE = '15_S01';
export const CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE = '16_S01';
export const BUNDLE_CARD_CASH_REWARDS = '00_E01';
export const BUNDLE_CARD_REWARDS_MVP = '01_E01';
export const BUNDLE_CARD_TRIPLE_CASH_REWARDS = '02_E01';
export const BUNDLE_CARD_UNLIMITED_CASH_REWARDS = '03_E01';
export const BUNDLE_CARD_REWARDS_BITCOIN_PLUS = '04_E01';
export const BUNDLE_CARD_REWARDS_ELITE = '05_E01';
export const ONE_CARD_CASH_REWARDS = 'OC_01';
export const ONE_CARD_CASH_REWARDS_SIMPLIFIED = 'OC_01_01';
export const ONE_CARD_1_5_CASH_REWARDS = 'OC_U01';
export const ONE_CARD_TRIPLE_CASH_REWARDS = 'OC_U02';
export const ONE_CARD_UNLIMITED_CASH_REWARDS = 'OC_U03';
export const ONE_CARD_SELECT = 'OCF_01_01';
export const SECURED_ONE_CARD = 'OCS_01_01';
export const SECURED_ONE_CARD_WITH_UPSELL = 'OCS_01_02';
export const SECURED_ONE_CARD_WITH_CSA = 'OCS_01_03';
export const SECURED_ONE_CARD_ZERO = 'OCS_01_01Z';
export const SECURED_ONE_CARD_ZERO_WITH_CSA = 'OCS_01_03Z';
export const GRADUATED_ONE_CARD = 'OCG_01_01';

// One Card Credit Builder
export const SECURED_ONE_CARD_CREDIT_BUILDER = 'OCS_CB_01';
export const INTRODUCTORY_CARD_REWARDS = '01_I01';
export const INTRODUCTORY_CARD_TRIPLE_CASH_REWARDS = '01_I02';
export const INTRODUCTORY_CARD_REWARDS_ELITE = '05_I01';
export const PARTNER_REWARD_PROGRAM = 'P_01';

// Deposit
export const DEP_CH_01 = 'DEP_CH_01';
export const DEP_CH_02 = 'DEP_CH_02';
export const DEP_CH_03 = 'DEP_CH_03';
export const DEP_CH_04 = 'DEP_CH_04';
export const DEP_SV_01 = 'DEP_SV_01';
export const DEP_SV_02 = 'DEP_SV_02';
export const DEP_SV_03 = 'DEP_SV_03';
export const DEP_SV_04 = 'DEP_SV_04';
export const DEP_SV_05 = 'DEP_SV_05';
export const DEP_SV_07 = 'DEP_SV_07';

// Deposit Credit Builder
export const DEP_CB_01 = 'DEP_CB_01';

// Flex Pay
export const FLEX_BNPL_DEFAULT = 'BNPL_DEFAULT';
export const FLEX_BNPL_POST_PAY = 'BNPL_POST_PAY';
export const FLEX_BNPL_MIGRATED = 'BNPL_MIGRATED';
export const FLEX_BNPL_POST_PAY_MIGRATED = 'BNPL_POST_PAY_MIGRATED';
export const FLEX_UPLIFT_BNPL_SHELL = 'UPLIFT_BNPL_SHELL';
export const FLEX_DEFAULT = FLEX_BNPL_DEFAULT; // DEPRECATED - use FLEX_BNPL_DEFAULT
export const FLEX_MIGRATED = FLEX_BNPL_MIGRATED; // DEPRECATED - use FLEX_BNPL_MIGRATED

// Secured Deposit:
export const DEP_SV_06 = 'DEP_SV_06';
export const DEP_SV_08 = 'DEP_SV_08';

// Cash Advance:
export const CASH_ADVANCE_DEFAULT = 'CASH_ADVANCE_DEFAULT';

// These are deprecated in favour of sets in utils/deposit/pdc.js
export const CHECKING_PROGRAM_DEFINITION_CODES = [DEP_CH_01, DEP_CH_02];
export const SAVINGS_PROGRAM_DEFINITION_CODES = [DEP_SV_01, DEP_SV_02, DEP_SV_03, DEP_SV_04, DEP_SV_05];
export const HYS_PROGRAM_DEFINITION_CODES = [DEP_SV_01, DEP_SV_04];
export const PS_PROGRAM_DEFINITION_CODES = [DEP_SV_02, DEP_SV_03, DEP_SV_05];